<div class="impact-item-date">{{ impact.date | date: 'longDate' }}</div>
<img class="impact-item-image" src="{{ impact.image }}">
<div class="impact-item-content">
  <div class="impact-item-title">{{ impact.title }}</div>
  <div class="impact-item-description">{{ impact.content }}</div>
  <a href="{{ impact.link }}"><div class="impact-item-learn-more"><img src="/assets/learn-more.svg">Learn More</div></a>
</div>